"use strict";
exports.__esModule = true;
exports.SvgToolbarUpgrade = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgToolbarUpgrade = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 20 20" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M10 2a8 8 0 110 16 8 8 0 010-16zm0 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zm.424 2.64l.08.069 2.278 2.261a.742.742 0 01.012 1.038.713.713 0 01-.939.082l-.082-.07-1.081-1.074v5.088a.728.728 0 01-.722.734.726.726 0 01-.716-.634l-.006-.1-.001-5.029-1.02 1.015a.713.713 0 01-.941.06l-.08-.072a.743.743 0 01-.06-.956l.072-.082 2.277-2.26a.717.717 0 01.93-.07z" }),
        react_1["default"].createElement("path", { d: "M0 0h20v20H0z" })))); };
//# sourceMappingURL=ToolbarUpgrade.js.map